import { render, staticRenderFns } from "./formatAbsentismos.vue?vue&type=template&id=08ed20fc"
import script from "./formatAbsentismos.vue?vue&type=script&lang=js"
export * from "./formatAbsentismos.vue?vue&type=script&lang=js"
import style0 from "./formatAbsentismos.vue?vue&type=style&index=0&id=08ed20fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports